function setCustomBackdropColor() {
	let backdrop : any = document.querySelector('.modal-backdrop');
    backdrop.style.background = 'var(--accent-color)';
    backdrop.style.opacity = 0.8;
}

function setModalContentClass() {
    let modalContent = document.querySelector('.modal-content');
    modalContent.classList.add('customized-modal-content');
}

export function setCustomModalClasses() {
    setCustomBackdropColor();
    setModalContentClass();
}